import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { BreadcrumbsItem, IsWebviewService } from '@alliance/clubs/utils'

import { RxStateComponent } from '@alliance/shared/models'
import { IconArrowsHorisontalDropdown } from '@alliance/shared/icons'

import { Translations } from '../../localization/translations'

@Component({
  selector: 'alliance-clubs-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends RxStateComponent<{
  items: BreadcrumbsItem[] | null
  isWebview: boolean
}> {
  public state = this.connectViewState(['items', 'isWebview'])
  public ICONS = { IconArrowsHorisontalDropdown: IconArrowsHorisontalDropdown.name }

  public constructor(public translations: Translations, private isWebviewService: IsWebviewService) {
    super()

    this.initState({
      items: null,
      isWebview: this.isWebviewService.select('isWebview')
    })
  }

  @Input()
  public set items(items: BreadcrumbsItem[]) {
    this.set({ items })
  }
  @Input()
  public set breadcrumbs(items: BreadcrumbsItem[]) {
    this.set({ items })
  }

  public trackByFn(index: number): number {
    return index
  }
}
